module.exports = __webpack_public_path__ + "img/sec3_line.c7bb6411.png";